export default __webpack_public_path__ + "static/media/fons-quadremedic.79b926e1.jpg";